import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setProjectTemplateActiveRecord } from 'data/templates/projects';
import { CellClickedEvent } from '../types';

type UseOnCellClickedFunction = () => (event: CellClickedEvent) => void;
export const useOnCellClicked: UseOnCellClickedFunction = () => {
  const dispatch = useDispatch();

  return useCallback(
    (event) => {
      if (event.data.data.isNew) {
        event.api.startEditingCell({
          rowIndex: event.rowIndex,
          colKey: event.column,
        });
      } else {
        dispatch(setProjectTemplateActiveRecord(event.data));
      }
    },
    [dispatch],
  );
};
